import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  ViewStyle,
  TextStyle,
  ScrollView,
} from 'react-native';
import colors from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';

type DropdownProps = Readonly<{
  options: string[];
  onSelect?: (value: string, index?:number) => void;
  style?: ViewStyle;
  textStyle?: TextStyle;
}>;

export function SimpleDropdown(props: DropdownProps) {
  const {options, onSelect, style, textStyle} = props;

  const handleSelect = (value: string, index: number) => {
    onSelect?.(value, index);
  };

  const defaultMaxHeight = 200;

  const scrollViewStyle = {
    maxHeight: style?.maxHeight ?? defaultMaxHeight,
  };

  return (
    <View style={[styles.container, style]}>
      <ScrollView style={scrollViewStyle} showsVerticalScrollIndicator={false}>
        <FlatList
          data={options}
          keyExtractor={item => item}
          renderItem={({item,index}) => (
            <TouchableOpacity
              onPress={() => handleSelect(item, index)}
              style={styles.option}>
              <Text style={[styles.optionText, textStyle]}>{item}</Text>
            </TouchableOpacity>
          )}
        />
      </ScrollView>
    </View>
  );
}

//define types
type styleTypes = {
  container: ViewStyle;
  option: ViewStyle;
  optionText: TextStyle;
};
const styles: styleTypes = {
  container: {
    backgroundColor: colors.palette.brandBlue10,
    width: '100%',
    borderRadius: corner_radius['rounded-sm'],
    shadowColor: colors.palette.black,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  option: {
    padding: spacing['2'],
  },
  optionText: {
    color: colors.palette.black,
    fontSize: 16,
    fontWeight: '400',
  },
};
